<template>
    <div id="us-all-container-topnavi">
        <div class="us-desctop-container">
            <a href="" class="top-navi-logo">
                <img src="../assets/images/logo.jpg" />
            </a>

            <div class="us-desctop-navi">
                <el-menu :default-active="activeIndex" mode="horizontal" v-for="(mn, a) in mainNavi" :key="a" class="descNavi">
                    <!-- :router="true" -->
                    <el-menu-item :index="mn.link" @click="goToSubmenuDesktop(a)">{{ mn.word }}</el-menu-item>
                </el-menu>
                <el-input placeholder="Suchen" v-model="usSearch" class="us-navi-search" size="mini" @keyup.enter.native="searchPage">
                    <el-button slot="append" icon="el-icon-search" @click="searchPage"></el-button>
                </el-input>
                <a @click="openMobilnav" class="burgerIcon">
                    <fai :icon="['fal', 'bars']"></fai>
                </a>
            </div>
        </div>
        <div class="us-desktop-submenu" @mouseleave="closeDesctopnav">
            <swiper :options="submenuDesktopSwiper" ref="submenuDesktopSwiper">
                <swiper-slide v-for="(navi, e) in mainNavi" :key="e" class="us-desktop-submenu-swiper">
                    <div v-for="(sub, f) in mainNavi[e].submenu" :key="f">
                        <div class="us-kat-cart-container" @click="goToContentDesctop(sub.link)">
                            <div class="us-kat-pic">
                                <img :src="sub.pic" />
                                <div class="us-kat-title-container">
                                    <div class="us-kat-title">{{ sub.word }}</div>
                                </div>
                                <div class="us-journey-pic-copyright-top">{{ sub.copy }}</div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>

        <div class="us-mobile-navi">
            <div style="width:100%;">
                <el-input placeholder="Suchen" v-model="usSearch" class="us-navi-search-mobil" size="mini" @keyup.enter.native="searchPage">
                    <el-button slot="append" icon="el-icon-search" @click="searchPage"></el-button>
                </el-input>
            </div>
            <div v-for="(navi, b) in mainNavi" :key="b">
                <div class="us-icon-container us-icon-container-medium" @click="goToSubmenu(b)" v-bind:class="{ usMenuactive: navi.isStat }">
                    <fai :icon="['fal', navi.icon]"></fai>
                    <span style="text-align:center;">{{ navi.short }}</span>
                </div>
            </div>
            <div style="width:100%;height:1px;background-color:#b90202;margin-top:20px;"></div>
            <div class="us-mobile-submenu">
                <swiper :options="submenuSwiper" ref="submenuSwiper">
                    <swiper-slide v-for="(navi, c) in mainNavi" :key="c" class="us-mobile-submenu-swiper">
                        <div v-for="(sub, d) in mainNavi[c].submenu" :key="d">
                            <div class="us-icon-container-light us-icon-container-medium" @click="goToContent(sub.link)">
                                <fai :icon="['fal', sub.icon]"></fai>
                                <span style="text-align:center;">{{ sub.short }}</span>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "topnavi",
    computed: {
        submenuSlider() {
            return this.$refs.submenuSwiper.swiper
        },
        submenuDesktopSlider() {
            return this.$refs.submenuDesktopSwiper.swiper
        }
    },
    components: {},
    data() {
        return {
            expand: false,
            usSearch: "",
            activeMobil: 0,
            activeIndex: "1",
            mainNavi: [
                {
                    word: "Unternehmen",
                    link: "1",
                    icon: "building",
                    short: "Unternehmen",
                    isStat: true,
                    submenu: [
                        { word: "Das sind Wir!", link: "/article/5", icon: "user-friends", short: "Wir", pic: "/bilder/catpic/wir.jpg", copy: "©REDPIXEL - stock.adobe.com" },
                        { word: "Historie", link: "/article/6", icon: "landmark", short: "Historie", pic: "/bilder/catpic/historie.jpg", copy: "©Kot63 - stock.adobe.com" },
                        { word: "Standorte", link: "/article/7", icon: "home", short: "Standorte", pic: "/bilder/catpic/standorte.jpg", copy: "" },
                        { word: "Fuhrpark", link: "/article/8", icon: "bus", short: "Fuhrpark", pic: "/bilder/catpic/fuhrpark.jpg", copy: "" },
                        { word: "Taxi", link: "/article/9", icon: "taxi", short: "Taxi", pic: "/bilder/catpic/taxi.jpg", copy: "©Corepics" },
                        { word: "Linie", link: "/article/10", icon: "shuttle-van", short: "Linie", pic: "/bilder/catpic/linie.jpg", copy: "©connel_design - stock.adobe.com" }
                    ]
                },
                {
                    word: "Reisen",
                    link: "2",
                    icon: "globe",
                    short: "Reisen",
                    isStat: false,
                    submenu: [
                        { word: "Reisekalender", link: "/journeyoverview", icon: "calendar-check", short: "Reisekalender", pic: "/bilder/catpic/kalender.jpg", copy: "©leszekglasner - stock.adobe.com" },
                        { word: "Kurz- und Städtereisen", link: "/journeycart/Kurz- und Städtereisen", icon: "archway", short: "Kurzreisen", pic: "/bilder/catpic/kurz.jpg", copy: "©Jan Christopher Becke" },
                        { word: "Erlebnis- & Aufenthaltsreisen", link: "/journeycart/Erlebnis- und Aufenthaltsreise", icon: "bed", short: "Erlebnisreisen", pic: "/bilder/catpic/erlebnis.jpg", copy: "©Maksim Pasko - stock.adobe.com" },
                        { word: "Musikreisen", link: "/journeycart/Musikreise", icon: "music", short: "Musikreisen", pic: "/bilder/catpic/musik.jpg", copy: "©anyaberkut - stock.adobe.com" },
                        { word: "Premiumreisen", link: "/journeycart/Premiumreise", icon: "tree-palm", short: "Premiumreisen", pic: "/bilder/catpic/premium.jpg", copy: "©VICUSCHKA - stock.adobe.com" },
                        { word: "Flugreisen", link: "/journeycart/Flugreisen", icon: "plane-departure", short: "Flugreisen", pic: "/bilder/catpic/flug.jpg", copy: "©anyaberkut - stock.adobe.com" },
                        { word: "Sonderreisen", link: "/journeycart/Sonderreisen", icon: "surprise", short: "Sondereisen", pic: "/bilder/catpic/sonder.jpg", copy: "©kwanchaichaiudom - stock.adobe.com" },
                        { word: "Advent & Weihnachten", link: "/journeycart/Weihnachten", icon: "sleigh", short: "Advent", pic: "/bilder/catpic/advent.jpg", copy: "©Jan Christopher Becke" },
                        { word: "Silvesterreisen", link: "/journeycart/Silvester", icon: "glass-cheers", short: "Silvester", pic: "/bilder/catpic/silvester.jpg", copy: "©gudrun - stock.adobe.com" },
                        { word: "Tagesreisen", link: "/journeycart/Tagesreisen", icon: "sunrise", short: "Tagesreisen", pic: "/bilder/catpic/tagesfahrt.jpg", copy: "©Petair - stock.adobe.com" }
                    ]
                },
                {
                    word: "Gruppen",
                    link: "3",
                    icon: "user-headset",
                    short: "Service",
                    isStat: false,
                    submenu: [
                        { word: "Busanmietung", link: "/formular/Busanmietung", icon: "bus-alt", short: "Busanmietung", pic: "/bilder/catpic/anmietung.jpg", copy: "©Syda Productions - stock.adobe.com" },
                        { word: "Gruppen- & Vereinsreisen", link: "/formular/Gruppen", icon: "user-friends", short: "Gruppen", pic: "/bilder/catpic/gruppen.jpg", copy: "©Robert Kneschke - stock.adobe.com" },
                        { word: "Klassen- & Schülerreisen", link: "/formular/Klassen", icon: "school", short: "Schüler", pic: "/bilder/catpic/schule.jpg", copy: "©pololia - stock.adobe.com" }
                    ]
                },
                {
                    word: "Service",
                    link: "4",
                    icon: "download",
                    short: "Service",
                    isStat: false,
                    submenu: [
                        { word: "Katalog bestellen", link: "/formular/Kataloganfordern", icon: "shopping-bag", short: "Katalog", pic: "/bilder/catpic/katalog.jpg", copy: "©Joachim Wendler - stock.adobe.com" },
                        { word: "Reisegutschein bestellen", link: "/formular/Gutschein", icon: "shopping-cart", short: "Gutschein", pic: "/bilder/catpic/gutschein.jpg", copy: "©Floydine - stock.adobe.com" },
                        { word: "Buchungsstellen", link: "/article/16", icon: "tty", short: "Buchungsstellen", pic: "/bilder/catpic/buchungsstellen.jpg", copy: "©panigystovska - stock.adobe.com" },
                        { word: "Haustürabholung", link: "/article/18", icon: "door-open", short: "Haustürabholung", pic: "/bilder/catpic/haus.jpg", copy: "©ALDECAstudio - stock.adobe.com" },
                        { word: "Frühbucherrabatt", link: "/article/19", icon: "euro-sign", short: "Frühbucherrabatt", pic: "/bilder/catpic/fruehbucher.jpg", copy: "©Maitree.B Hin255" },
                        { word: "Gruppenrabatt", link: "/article/20", icon: "grin-stars", short: "Gruppenrabatt", pic: "/bilder/catpic/gruppenrab.jpg", copy: "©Antonioguillem - stock.adobe.com" },
                        { word: "Kinderermäßigung", link: "/article/21", icon: "smile-wink", short: "Kinder", pic: "/bilder/catpic/kinder.jpg", copy: "©Carmen 56 - stock.adobe.com" },
                        { word: "Neukundengewinnung", link: "/article/22", icon: "grin-hearts", short: "Neukunden", pic: "/bilder/catpic/neukunden.jpg", copy: "©momius - stock.adobe.com" },
                        { word: "Treueklee", link: "/article/23", icon: "hands-helping", short: "Treueklee", pic: "/bilder/catpic/klee.jpg", copy: "© Sonja Calovini - stock.adobe.com" },
                        { word: "Reiseversicherung", link: "/article/24", icon: "user-injured", short: "Versicherung", pic: "/bilder/catpic/versicherung.jpg", copy: "©Mediteraneo - stock.adobe.com" }
                    ]
                }
            ],

            submenuSwiper: {
                direction: "horizontal",
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000
            },
            submenuDesktopSwiper: {
                direction: "horizontal",
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                autoHeight: true
                //   simulateTouch: false
            }
        }
    },
    methods: {
        goToContent(link) {
            this.openMobilnav()
            this.$emit("getTopSliderTop")
            this.$router.push({ path: link })
        },
        goToContentDesctop(link) {
            //   console.log(link)
            this.expand = true
            this.openDesctopnav()
            this.$emit("getTopSliderTop")
            //  this.$router.push({path: '/journeycart/1' })
            this.$router.push({ path: link })
        },
        goToSubmenu(link) {
            for (var i = 0; i < this.mainNavi.length; i++) {
                this.mainNavi[i].isStat = false
            }
            this.mainNavi[link].isStat = true
            this.submenuSlider.slideTo(link, 1000, false)
            this.activeMobil = link
        },
        goToSubmenuDesktop(link) {
            this.openDesctopnav()
            this.submenuDesktopSlider.slideTo(link, 1000, false)
        },
        openMobilnav() {
            var el = document.querySelector(".us-mobile-navi")
            var h = el.offsetHeight
            if (this.expand == false) {
                el.style.top = "60px"
                this.expand = true
                this.submenuSlider.slideTo(this.activeMobil, 1000, false)
            } else {
                el.style.top = -h + "px"
                this.expand = false
            }
        },
        openDesctopnav() {
            var el = document.querySelector(".us-desktop-submenu")
            var h = el.offsetHeight
            if (this.expand == false) {
                el.style.top = "60px"
            } else {
                el.style.top = -h + "px"
                this.expand = false
            }
        },
        closeDesctopnav() {
            var el = document.querySelector(".us-desktop-submenu")
            var h = el.offsetHeight
            el.style.top = -h + "px"
            this.expand = false
        },
        searchPage() {
            this.$router.push({ path: "/search/" + this.usSearch })
        }
    }
}
</script>


<style lang="scss">
.burgerIcon {
    margin-top: 22px;
    margin-right: 15px;
    display: block !important;
    cursor: pointer;
}
.descNavi {
    margin-top: 5px !important;
    margin-right: 15px !important;
    display: none !important;
}
.us-mobile-navi {
    // background:green;
    transition: all 1s;
    width: 80%;
    clear: both;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    justify-content: center;
    padding: 2% 10% 10% 10%;
    background-color: #fff;
    position: absolute;
    top: -1000px;
    z-index: 0;
    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.75);
}
.us-navi-search-mobil {
    margin: auto !important;
    margin-bottom: 10px !important;
}

.us-mobile-submenu {
    margin-top: 20px;
    width: 100%;
}
.us-mobile-submenu-swiper {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-self: flex-start;
    align-items: flex-start;
    justify-content: center;
}
.usMenuactive {
    color: #b90202 !important;
    border: 1px solid #b90202 !important;
}

.us-desktop-submenu {
    position: absolute;
    top: 100px;
    z-index: 0;
    width: 100%;
    height: 300px;

    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.75);
    display: none !important;
    background-color: rgb(228, 230, 238);
}

@media (min-width: 100px) {
    #us-all-container-topnavi {
        width: 100px !important;
    }

    .us-desctop-container {
        position: relative;
        top: 0px;
        left: 0px;
        height: 100%;
        z-index: 10;
        background: #fff;
    }

    .top-navi-logo {
        float: left;
        margin-left: 15px;
        margin-top: 10px;
    }
    .us-desctop-navi {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        // position:absolute;
        // z-index:2;
    }
    .us-desctop-navi .el-menu--horizontal {
        border-bottom: 0px !important;
    }
    .us-desctop-navi .el-menu--horizontal > .el-menu-item {
        font-size: 15px;
        padding: 0 5px;
        height: 50px;
        line-height: 50px;
        border-bottom: 0px !important;
    }

    .us-top-navi .is-active {
        border-bottom: none !important;
    }
    .us-navi-search {
        width: 200px !important;
        margin-top: 15px !important;
        margin-right: 15px !important;
    }
}

@media (max-width: 1200px) {
    .us-desctop-navi .el-menu--horizontal > .el-menu-item {
        font-size: 13px;
        padding: 0 5px;
        height: 50px;
        line-height: 50px;
        border-bottom: 0px !important;
    }
}
@media (max-width: 1100px) {
    .us-desctop-navi .el-menu--horizontal > .el-menu-item {
        font-size: 11px;
        padding: 0 3px;
        height: 50px;
        line-height: 50px;
        border-bottom: 0px !important;
    }
}
@media (max-width: 1000px) {
    .us-navi-search {
        width: 120px !important;
        margin-top: 15px !important;
        margin-right: 15px !important;
    }
}
@media (max-width: 900px) {
    .us-navi-search {
        width: 170px !important;
        margin-top: 15px !important;
        margin-right: 15px !important;
    }
}
@media (max-width: 900px) {
    .us-navi-search {
        visibility: hidden !important;
    }
}

@media (min-width: 900px) {
    .burgerIcon {
        margin-top: 22px;
        margin-right: 15px;
        display: none !important;
    }
    .descNavi {
        margin-top: 5px !important;
        margin-right: 15px !important;
        display: block !important;
    }

    .us-mobile-navi {
        width: 80%;
        clear: both;
        display: none !important;
        flex-direction: row;
        flex-flow: wrap;
        justify-content: center;
        padding: 2% 10% 10% 10%;
        background-color: #fff;
        position: absolute;
        top: 60px;
        z-index: 0;
        box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.75);
    }
    .us-navi-search-mobil {
        margin-left: 0px !important;
        margin-bottom: 10px !important;
        width: 85% !important;
    }

    .us-desktop-submenu {
        position: absolute;
        top: -1000px;
        z-index: 0;
        width: 100%;
        height: auto;
        background: linear-gradient(to bottom, rgba(252, 255, 244, 1) 0%, rgba(181, 188, 177, 0.91) 100%);
        box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.75);
        display: block !important;
        padding-top: 20px;
        padding-bottom: 20px;
        transition: all 1s;
    }
    .us-desktop-submenu-swiper {
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
        align-self: flex-start;
        align-items: flex-start;
        justify-content: center;
    }
    .us-kat-cart-container {
        width: 15vw;
        height: 10vw;
        background: #fff;
        margin: 0.3vw;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px #676767;
        border: 1px solid #676767;
        cursor: pointer;
        transition: all 0.5s;
    }
    .us-kat-cart-container:hover {
        box-shadow: 0px 0px 5px 0px #676767;
        transform: scale(0.95);
        .us-kat-pic img {
            transform: scale(1.5);
        }
    }
    .us-kat-pic {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .us-kat-pic img {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
    }

    .us-kat-title-container {
        position: absolute;
        right: 0px;
        bottom: 0px;
        width: 100%;
        height: 3vw;
        background: rgba(0, 0, 0, 0.2);
    }
    .us-kat-title {
        position: absolute;
        right: 0.5vw;
        bottom: 0.5vw;
        text-align: right;
        color: #fff;
        font-weight: bold;
        font-size: 1vw;
        text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
    }

    .us-journey-pic-copyright-top {
        width: 100%;
        position: absolute;
        z-index: 20;
        top: 5px;
        left: 5px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 9px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2);
    }
}
</style>





